import { useEffect, useState } from 'react';

export default function ClientsSection() {
  const clients = [
    {
      name: "Arasa",
      logo: "https://static.readdy.ai/image/a74dd7e7f2d6adb4e533c9016359af25/1b92e7a5da08b5a25fc5ea3026e0a0a4.png",
      description: "Embalagens",
      website: "https://arasa.com.br"
    },
    {
      name: "ConheSendo",
      logo: "https://static.readdy.ai/image/a74dd7e7f2d6adb4e533c9016359af25/c2ef4968a49ef2f4ebb97df510b0fc06.png",
      description: "Desenvolvimento Pessoal",
      website: "https://conhesendo.com.br"
    },
    {
      name: "Glass",
      logo: "https://static.readdy.ai/image/a74dd7e7f2d6adb4e533c9016359af25/a8df9ffc6658da4e81f40d6692d7f94a.png",
      description: "Embalagens",
      website: "https://glasembalagens.com.br"
    },
    {
      name: "Viprem",
      logo: "https://static.readdy.ai/image/a74dd7e7f2d6adb4e533c9016359af25/031385ee722ba39affacf9f87538f7e2.png",
      description: "Comércio de Embalagens",
      website: "https://www.viprem.com.br"
    },
    {
      name: "Mat Sports",
      logo: "https://static.readdy.ai/image/a74dd7e7f2d6adb4e533c9016359af25/4386196d9ab3ae2f87253893b019deda.png",
      description: "Licenciamento de Marcas",
      website: "https://matsports.com.br"
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    if (!isHovered && !isTransitioning) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % clients.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [isHovered, isTransitioning, currentIndex]);

  const nextSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentIndex((prevIndex) => (prevIndex + 1) % clients.length);
    setTimeout(() => setIsTransitioning(false), 500);
  };

  const prevSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentIndex((prevIndex) => (prevIndex - 1 + clients.length) % clients.length);
    setTimeout(() => setIsTransitioning(false), 500);
  };

  const goToSlide = (index: number) => {
    if (isTransitioning || index === currentIndex) return;
    setIsTransitioning(true);
    setCurrentIndex(index);
    setTimeout(() => setIsTransitioning(false), 500);
  };

  return (
    <section id="clientes" className="py-20 bg-gray-900">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">
            Nossos <span className="text-orange-500">Clientes</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Empresas que confiam na MPG System para otimizar seus processos e impulsionar seus resultados
          </p>
        </div>

        <div 
          className="relative overflow-hidden max-w-md mx-auto"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {/* Navigation Arrows */}
          <button
            onClick={prevSlide}
            disabled={isTransitioning}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 z-10 hover:bg-white/10 text-white p-3 rounded-full transition-all duration-300 backdrop-blur-sm border border-white/20 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <i className="ri-arrow-left-line text-xl"></i>
          </button>
          
          <button
            onClick={nextSlide}
            disabled={isTransitioning}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 z-10 hover:bg-white/10 text-white p-3 rounded-full transition-all duration-300 backdrop-blur-sm border border-white/20 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <i className="ri-arrow-right-line text-xl"></i>
          </button>

          {/* Clients Carousel */}
          <div className="px-16">
            <div className="relative h-80 overflow-hidden">
              {clients.map((client, index) => (
                <div
                  key={index}
                  className={`absolute inset-0 transition-all duration-500 ease-in-out ${
                    index === currentIndex 
                      ? 'opacity-100 translate-x-0' 
                      : index < currentIndex 
                        ? 'opacity-0 -translate-x-full' 
                        : 'opacity-0 translate-x-full'
                  }`}
                >
                  <div className="h-full flex items-center justify-center">
                    <div className="group bg-white/5 backdrop-blur-sm rounded-xl p-8 hover:bg-white/10 transition-all duration-500 hover:scale-105 border border-gray-700/50 w-full max-w-sm">
                      {client.website ? (
                        <a 
                          href={client.website}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex flex-col items-center text-center cursor-pointer"
                        >
                          <div className="w-32 h-32 mb-6 bg-white rounded-lg p-4 flex items-center justify-center group-hover:shadow-lg transition-shadow mx-auto">
                            <img
                              src={client.logo}
                              alt={`Logo ${client.name}`}
                              className="max-w-full max-h-full object-contain filter grayscale group-hover:grayscale-0 transition-all duration-300"
                            />
                          </div>
                          <h3 className="text-xl font-semibold text-white mb-3 group-hover:text-orange-500 transition-colors">{client.name}</h3>
                          <p className="text-base text-gray-400">{client.description}</p>
                        </a>
                      ) : (
                        <div className="flex flex-col items-center text-center">
                          <div className="w-32 h-32 mb-6 bg-white rounded-lg p-4 flex items-center justify-center group-hover:shadow-lg transition-shadow mx-auto">
                            <img
                              src={client.logo}
                              alt={`Logo ${client.name}`}
                              className="max-w-full max-h-full object-contain filter grayscale group-hover:grayscale-0 transition-all duration-300"
                            />
                          </div>
                          <h3 className="text-xl font-semibold text-white mb-3">{client.name}</h3>
                          <p className="text-base text-gray-400">{client.description}</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Dots Indicator */}
          <div className="flex justify-center mt-8 space-x-2">
            {clients.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                disabled={isTransitioning}
                className={`w-3 h-3 rounded-full transition-all duration-300 disabled:cursor-not-allowed cursor-pointer ${
                  index === currentIndex 
                    ? 'bg-orange-500 scale-125' 
                    : 'bg-gray-600 hover:bg-gray-500'
                }`}
              />
            ))}
          </div>
        </div>

        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-orange-500/10 to-orange-600/10 rounded-2xl p-8 border border-orange-500/20">
            <h3 className="text-2xl font-bold text-white mb-4">
              Seja nosso próximo cliente de sucesso
            </h3>
            <p className="text-gray-300 mb-6 max-w-2xl mx-auto">
              Junte-se a essas empresas que já transformaram seus processos com nossas soluções tecnológicas
            </p>
            <a
              href="https://wa.me/5511930682731"
              className="inline-flex items-center px-8 py-3 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              Fale conosco agora
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
